import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import groupsService from '@Groups/service/groups.service';
import Vue from 'vue';

const defaultOptions = { page: 1, itemsPerPage: 15, sortBy: [], sortDesc: [], search: '' };

export const GROUPS = {
    namespaced: true,
    state: {
        entries: [],
        total: 0,
        loading: false,
        options: { ...defaultOptions },
        selectedGroup: null,
    },
    getters: {
        GET_ENTRIES(state) {
            return state.entries;
        },
        GET_TOTAL(state) {
            return state.total;
        },
        GET_LOADING(state) {
            return state.loading;
        },
        GET_OPTIONS(state) {
            return state.options;
        },
        GET_SELECTED_GROUP(state) {
            return state.selectedGroup;
        },
    },
    mutations: {
        SET_ENTRIES(state, value) {
            state.entries = value;
        },
        SET_TOTAL(state, value) {
            state.total = value;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_OPTIONS(state, value) {
            state.options = { ...state.options, ...value };
        },
        RESET_OPTIONS(state) {
            state.options = { ...defaultOptions };
        },
        SET_SELECTED_GROUP(state, value) {
            state.selectedGroup = value;
        },
    },
    actions: {
        GET_GROUPS({ commit }) {
            commit('SET_LOADING', true);
            return groupsService.get({
                pageNumber: 1,
                pageSize: 1000,
                sortColumn: 'name',
                sortDirection: 'asc',
            }).then((res) => {
                return (res.data.items);
            }).catch((err) => {
                $handleError(err);
            }).finally(() => {
                commit('SET_LOADING', false);
            });
        },
        GET({ commit, state }) {
            commit('SET_LOADING', true);
            const params = {
                ...state.options,
                // Convert Vue data table format to server format
                pageNumber: state.options.page,
                pageSize: state.options.itemsPerPage,
                searchTerm: state.options.search,
                sortColumn: state.options.sortBy.length > 0 ? state.options.sortBy[0] : null,
                sortDirection: state.options.sortDesc.length > 0 && state.options.sortDesc[0] ? 'desc' : 'asc',
            };

            return groupsService
                .get(params)
                .then((res) => {
                    const data = res.data.items || res.data;
                    commit('SET_ENTRIES', data);
                    commit('SET_TOTAL', res.data.total || data.length);
                })
                .catch((err) => {
                    $handleError(err);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },

        GET_BY_ID({ commit }, id) {
            return groupsService.getById(id).then((res) => {
                commit('SET_SELECTED_GROUP', res.data);
                return res.data;
            });
        },

        CREATE({ state, commit }, data) {
            return groupsService.create(data).then((res) => {
                $updateOrAdd(state.entries, res.data, 'id', true);
                commit('SET_TOTAL', state.total + 1);
                Vue.prototype.$dialog.notify.success('Group created successfully', {
                    position: 'top-right',
                    timeout: 3000,
                });
                return res.data;
            });
        },

        UPDATE({ state }, data) {
            return groupsService.update(data).then((res) => {
                $updateOrAdd(state.entries, res.data, 'id', true);
                Vue.prototype.$dialog.notify.success('Group updated successfully', {
                    position: 'top-right',
                    timeout: 3000,
                });
                return res.data;
            });
        },

        DELETE({ state, commit }, id) {
            return groupsService
                .delete(id)
                .then(() => {
                    $deleteFromArray(state.entries, id);
                    commit('SET_TOTAL', state.total - 1);
                    Vue.prototype.$dialog.notify.success('Group deleted successfully', {
                        position: 'top-right',
                        timeout: 3000,
                    });
                })
                .catch((err) => {
                    $handleError(err);
                });
        },
    },
};
